import { Component } from '@angular/core';
import {Quota, UserService} from "../user.service";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-credit-display',
  templateUrl: './credit-display.component.html',
  styleUrls: ['./credit-display.component.scss'],
})
export class CreditDisplayComponent {
  quota$ = this.userService.quota;

  constructor(private userService: UserService) {
    this.userService.refresh();
  }
}